import styled from "styled-components";
import { Radio, Select, Modal } from "antd";
import { COLORS, WEIGHT } from "../../../../layout/theme";

export const Inner = styled.div`
	& .noBackground,
	& .noBackground:hover {
		background-color: ${COLORS.White} !important;
		border: none;
	}
`;

export const Filters = styled.div`
	& button {
		padding: 0 !important;
	}
`;

export const RadioOptions = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-top: 20px;
	margin-bottom: 20px;

	.ant-radio-group {
		display: flex;
		flex-wrap: wrap;
		gap: 8px;
	}

	.ant-btn {
		border-radius: 10px !important;
	}
`;

export const AntdRadioButton = styled(Radio.Button)`
	border: 1px solid #e5e7eb !important;
	border-radius: 10px !important;
	font-weight: ${WEIGHT.Bold};
	background: #ffffff !important;
	color: #6b7280 !important;
	box-shadow: none !important;

	&.ant-radio-button-wrapper-checked {
		background: #eef2ff !important;
		border-color: #c7d2fe !important;
		color: #3730a3 !important;
	}

	&:before {
		display: none !important;
	}
`;

export const AntdSelect = styled(Select)`
	border: none;
	font-weight: ${WEIGHT.SemiBold};
	min-width: 150px;
`;

export const AntdOption = styled.div`
	border: none;
	font-weight: ${WEIGHT.SemiBold};
	color: ${COLORS.Grey};
`;

export const PreviewImage = styled.img`
	width: 150px;
	height: 150px;
	object-fit: contain;
`;

export const UserAvatar = styled.div`
	width: 40px;
	height: 40px;
	border-radius: 999px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 14px;
	font-weight: 800;
	background: ${(props) => props.bg || "#EEF2FF"};
	color: ${(props) => props.color || "#4338CA"};
	text-transform: uppercase;
`;

export const UserPhoto = styled.img`
	width: 40px;
	height: 40px;
	border-radius: 999px;
	object-fit: cover;
	display: block;
`;

export const RoleTag = styled.span`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	padding: 5px 12px;
	border-radius: 999px;
	font-size: 12px;
	font-weight: 800;
	line-height: 1;
	white-space: nowrap;
	background: ${(props) => props.bg || "#F3F4F6"};
	color: ${(props) => props.color || "#374151"};
`;

export const StatusText = styled.span`
	font-size: 14px;
	font-weight: 700;
	color: ${(props) => (props.active ? "#16A34A" : "#9CA3AF")};
`;

export const ActionButton = styled.button`
	border: none;
	border-radius: 8px;
	background-color: transparent;
	padding: 6px;
	cursor: pointer;
	color: ${COLORS.Primary};
	display: inline-flex;
	align-items: center;
	justify-content: center;

	&:hover {
		background-color: #eef2ff;
	}
`;

export const NameText = styled.div`
	font-size: 14px;
	font-weight: 700;
	color: #111827;
	cursor: pointer;
`;

export const EmailText = styled.div`
	font-size: 14px;
	font-weight: 500;
	color: #374151;
`;

export const AvatarCell = styled.div`
	display: flex;
	align-items: center;
`;

export const AntdModal = styled(Modal)`
	.ant-modal-content {
		border-radius: 10px;
	}

	.ant-modal-header {
		border-radius: 10px 10px 0 0;
	}

	.ant-modal-body {
		background-color: ${COLORS.LightGrey};
		padding: 1rem 5rem 1rem 5rem;
		border-radius: 0 0 10px 10px;
	}

	.ant-modal-footer {
		text-align: left;
		height: 80px;
	}
`;

export const FilterContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 16px;
	align-items: center;

	.ant-picker,
	.ant-select-selector {
		height: 35px !important;
		border-radius: 14px !important;
		border: 1px solid #cbd5e1 !important;
		box-shadow: none !important;
		font-size: 16px !important;
	}

	.ant-picker {
		padding: 0 16px !important;
	}

	.ant-select-selector {
		padding: 0 16px !important;
		display: flex !important;
		align-items: center !important;
	}

	.ant-select-selection-placeholder,
	.ant-select-selection-item {
		color: #334155 !important;
		font-size: 16px !important;
	}

	.ant-picker:hover,
	.ant-picker-focused,
	.ant-select-focused .ant-select-selector,
	.ant-select:hover .ant-select-selector {
		border-color: #4f46e5 !important;
		box-shadow: 0 0 0 2px rgba(79, 70, 229, 0.08) !important;
	}

	.ant-picker-range {
		min-width: 260px;
	}

	@media only screen and (max-width: 1200px) {
		.ant-picker-range,
		.ant-select,
		.ant-input-affix-wrapper {
			flex: 1 1 220px;
			min-width: 220px;
		}
	}

	@media only screen and (max-width: 768px) {
		.ant-picker-range,
		.ant-select,
		.ant-input-affix-wrapper {
			width: 100%;
			min-width: 100%;
		}
	}
`;

export const FilterSection = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

export const FilterActions = styled.div`
	display: flex;
	gap: 12px;
	align-items: center;
	margin-left: auto;

	@media only screen and (max-width: 1200px) {
		margin-left: 0;
	}

	@media only screen and (max-width: 768px) {
		width: 100%;
		flex-direction: column;
	}
`;
